export default __webpack_public_path__ + "static/media/person_place.472b5b53.svg";